import Link from 'next/link'

const TermsLabelComponent = (
  <p>
    I agree to the Codingal{' '}
    <Link href="/terms/" prefetch={false}>
      <a className="text-blue-200" target="_blank">
        Terms of Service
      </a>
    </Link>{' '}
    and{' '}
    <Link href="/privacy-policy/" prefetch={false}>
      <a className="text-blue-200" target="_blank">
        Privacy Policy
      </a>
    </Link>
  </p>
)

export default TermsLabelComponent
